<template>
  <div>
    <b-overlay :show="loading">
      <employee-public-info  :hidebacknext="true"></employee-public-info>

      <b-row class="mt-4 align-items-center">
        <b-col cols="12" md="12" class="d-flex justify-content-end align-items-center">
          <b-button v-if="(selectedOvertimeRow == null || selectedOvertimeRow.salary_settled == 0) && can_edit" variant="primary" @click="applyAndShowRunModal"
                    :disabled="overtimeDetails.length === 0 || loading" class="px-4 py-2 shadow-sm font-weight-bold">
            <i class="fa fa-sync-alt mr-2"></i> Give Payment Approval for Selected and Recalculate Draft
          </b-button>
        </b-col>
      </b-row>
      <div class="table-responsive employee-table-wrapper mt-3">
        <table class="employee-list-table table-overflow ess-custom-table document-table tax-documents table-list fund_list_table dataTable">
          <thead class="table-head">
          <tr>
            <td class="checkbox-col pl-3" v-if="(selectedOvertimeRow == null || selectedOvertimeRow.salary_settled == 0) && can_edit">
              <input type="checkbox" class="mt-0" v-model="selectAllFinal" @change="toggleAllFinal"/>
              <label for=""></label>
            </td>
            <th>Date & Shift Details</th>
            <th>Actual Working Time</th>
            <th>OT Before Clock In</th>
            <th>OT After Clock Out</th>
            <th>Suggested Overtime</th>
            <th>Work Day Type</th>
            <th>Salary Benefit Days</th>
            <th>Overtime Benefit</th>
            <th v-if="can_edit">Proposed Overtime</th>
            <th>Payment Approval Status</th>
          </tr>
          </thead>

          <tbody>
          <tr v-for="(data, index) in overtimeDetails" :key="data.id" 
              class="hover-bg table-row border-bottom mx-2 transition-all"
              :style="Number(data.final) === 1 ? 'background-color: rgba(40, 167, 69, 0.04); transition: background-color 0.2s;' : 'transition: background-color 0.2s;'">
            <td class="checkbox-col pl-3" v-if="(selectedOvertimeRow == null || selectedOvertimeRow.salary_settled == 0) && can_edit">
              <input class="mt-0" type="checkbox" v-model="data.selected" :true-value="1" :false-value="0" @change="syncSelectAllFinal"/>
              <label for=""></label>
            </td>

            <td>
              {{ data.date }} <br/>
              <span class="shift-badge px-1 py-3 rounded">{{ data.shift }}</span> <br/>
              {{ data.start_time }} - {{ data.end_time }} <br/>
              <span v-if="data.start_time && data.end_time">{{ getShiftDuration(data.start_time, data.end_time) }}</span>
            </td>
            <td>
              <template v-if="data.check_in || data.check_out">
                {{ data.check_in }} - {{ data.check_out }}
              </template>
              <template v-else>
                -
              </template>
              <br v-if="data.day_type == 0 && data.worktime"/>
              <span v-if="data.day_type == 0 && data.worktime">{{ data.worktime }} minutes</span>
            </td>
            <td>
              <template v-if="data.before_overtime > 0">{{ data.before_overtime }} minutes</template>
              <template v-else>-</template>
            </td>
            <td>
              <template v-if="data.after_overtime > 0">{{ data.after_overtime }} minutes</template>
              <template v-else>-</template>
            </td>
            <td v-if="data.day_type == 0">{{ data.overtime }} minutes</td>
            <td v-else>Full Day</td>
            <td>{{ daytypes[data.day_type] }}</td>
            <td>{{ data.salary_days }}</td>
            <td>{{ data.salary_minutes }} minutes</td>
            <td v-if="can_edit">
              <div v-if="selectedOvertimeRow == null || selectedOvertimeRow.salary_settled == 0" class="d-flex align-items-center">
                <template v-if="data.day_type == 0">
                  <b-form-input v-model="data.p_overtime" name="p_overtime" id="p_overtime" type="text" min="0" step="1" class="text-right" style="max-width: 90px; opacity: 1; padding-right: 5px !important;" v-validate="{ numeric: true }" :state="validateState('p_overtime')" aria-describedby="p_overtime-feedback" data-vv-as="Proposed Overtime"></b-form-input>
                  <span class="ml-1">min</span>
                </template>
                <span v-else>Full Day</span>
              </div>

              <span v-else>
                {{ data.p_overtime }} min
              </span>
            </td>
            <td>
              <span v-if="Number(data.final) === 1" class="">
                <i class="fa fa-check-circle mr-1"></i> Approved For Payment
              </span>
              <span v-else class="">
                <i class="fa fa-times-circle mr-1"></i> Not Approved For Payment
              </span>
            </td>
          </tr>

          <tr v-if="overtimeDetails.length == 0">
            <td colspan="12" class="text-center">No detail rows found.</td>
          </tr>
          </tbody>
        </table>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: ['row', 'can_edit'],
  data() {
    return {
      selectAllFinal: false,
      payrun_date: '',
      showDateFilter: false,
      daytypes: ["Hourly", "Off Day", "Holiday"],
      loading: false,
      overtimes: [],
      overtimeDetails: [],
      selectedOvertimeId: null,
      selectedOvertimeRow: null,
      settledSummary: {
        compensatory_leave: 0,
        salary_days: 0,
        salary_type_label: "-",
      },
      currentStep: 0,
      maxUnlockedStep: 0,
      bypassStep5Validation: false,
      selectedOvertimeRows: [],
      selectAllOvertimes: false,
      emptytext: "No records found.",
      employee: {
        name: "",
        employee_code: "",
        pic: "",
        company_id: null,
      },
      year: new Date().getFullYear(),
      month: String(new Date().getMonth() + 1).padStart(2, "0"),
      monthOptions: [
        { value: 1, text: "January" },
        { value: 2, text: "February" },
        { value: 3, text: "March" },
        { value: 4, text: "April" },
        { value: 5, text: "May" },
        { value: 6, text: "June" },
        { value: 7, text: "July" },
        { value: 8, text: "August" },
        { value: 9, text: "September" },
        { value: 10, text: "October" },
        { value: 11, text: "November" },
        { value: 12, text: "December" }
      ],
      selected_run_action: "",
      yearOptions: [],
      date_range_mode: "",
      dateRangeModeOptions: [
        { text: "Include Date Range", value: "include" },
        { text: "Exclude Date Range", value: "exclude" }
      ],
      range_from_date: "",
      range_to_date: "",
      overtimeFields: [
        { key: "employee_code", label: "Employee Code" },
        { key: "name", label: "Employee Name" },
        { key: "attendance_from", label: "From" },
        { key: "attendance_to", label: "To" },
        { key: "compensatory_leave", label: "Compensatory Leave" },
        { key: "salary_days", label: "Salary Benefit Days" },
        { key: "salary_minutes", label: "Salary Minutes" },
        { key: "p_overtime", label: "Proposed Overtime" },
        { key: "salary_type_label", label: "Salary Type" },
        { key: "status", label: "Status" }
      ],
    };
  },

  computed: {
    minDate() {
      if (!this.year || !this.month) {
        return "";
      }
      let payrunDay = Number(this.payrun_date);
      if (!payrunDay) {
        return moment(`${this.year}-${this.month}-01`, "YYYY-MM-DD").format("YYYY-MM-DD");
      }
      let selectedMonthStart = moment(`${this.year}-${this.month}-01`, "YYYY-MM-DD");
      let previousMonthStart = selectedMonthStart.clone().subtract(1, "month");
      let previousMonthLastDay = previousMonthStart.clone().endOf("month").date();
      let previousPayrunDay = payrunDay;
      if (payrunDay > previousMonthLastDay) {
        previousPayrunDay = previousMonthLastDay;
      }
      let previousPayrunDate = previousMonthStart.clone().date(previousPayrunDay);
      let minDate = previousPayrunDate.clone().add(1, "day");
      return minDate.format("YYYY-MM-DD");
    },
    maxDate() {
      if (!this.year || !this.month) {
        return "";
      }
      let payrunDay = Number(this.payrun_date);
      if (!payrunDay) {
        return moment(`${this.year}-${this.month}-01`, "YYYY-MM-DD").endOf("month").format("YYYY-MM-DD");
      }
      let selectedMonthStart = moment(`${this.year}-${this.month}-01`, "YYYY-MM-DD");
      let selectedMonthLastDay = selectedMonthStart.clone().endOf("month").date();
      let currentPayrunDay = payrunDay;
      if (payrunDay > selectedMonthLastDay) {
        currentPayrunDay = selectedMonthLastDay;
      }
      let maxDate = selectedMonthStart.clone().date(currentPayrunDay);
      return maxDate.format("YYYY-MM-DD");
    },
    summary() {
      let approvedCount = 0;
      let totalPOvertime = 0;
      let totalSalaryDays = 0;

      (this.overtimeDetails || []).forEach(item => {
        if (Number(item.final) === 1) {
          approvedCount++;
          if (item.day_type == 0) {
            totalPOvertime += Number(item.p_overtime || 0);
          } else {
            totalSalaryDays += Number(item.salary_days || 0);
          }
        }
      });

      return {
        approvedCount,
        totalPOvertime,
        totalSalaryDays,
        totalOvertimes: this.overtimeDetails.length
      };
    }
  },

  watch: {
    month: function () {
      this.validateDate();
    },

    year: function () {
      this.validateDate();
    },

    selectAllOvertimes: function () {
      this.toggleSelectAllOvertimes();
    },
  },

  methods: {
    getShiftDuration(start, end) {
      if (!start || !end) return "";
      let startTime = moment(start, "hh:mm A");
      let endTime = moment(end, "hh:mm A");
      if (endTime.isBefore(startTime)) {
        endTime.add(1, "day");
      }
      return endTime.diff(startTime, "minutes") + " minutes";
    },
    buildRequestFormData() {
      const formData = new FormData();
      formData.append("year", this.year);
      formData.append("month", this.month);
      formData.append("date_range_mode", this.date_range_mode);
      formData.append("range_from_date", this.range_from_date || "");
      formData.append("range_to_date", this.range_to_date || "");
      return formData;
    },

    toggleAllFinal() {
      const val = this.selectAllFinal ? 1 : 0;
      if (this.selectedOvertimeRow && this.selectedOvertimeRow.salary_settled != 1 && this.selectedOvertimeRow.status != 2) {
        this.overtimeDetails.forEach(item => this.$set(item, 'selected', val));
      }
    },

    syncSelectAllFinal() {
      this.selectAllFinal = this.overtimeDetails.length > 0 && this.overtimeDetails.every(item => Number(item.selected) === 1);
    },

    resetStepsAfter(step) {
      if (step <= 1) {
        this.selected_run_action = "";
      }

      if (step <= 2) {
        this.date_range_mode = "";
        this.range_from_date = "";
        this.range_to_date = "";
        this.overtimes = [];
        this.selectedOvertimeRows = [];
        this.selectAllOvertimes = false;
        this.emptytext = "No records found.";
      }

      if (step <= 3) {
        this.overtimeDetails = [];
        this.selectedOvertimeId = null;
        this.selectedOvertimeRow = null;
        this.employee = {
          name: "",
          employee_code: "",
          pic: "",
          company_id: null
        };
      }

      if (step <= 4) {
        this.settledSummary = {
          compensatory_leave: 0,
          salary_days: 0,
          salary_type_label: "-",
        };
      }

      this.maxUnlockedStep = step;
    },

    onComplete() {
      this.$bvToast.toast("Overtime flow completed.", {
        variant: "success",
        title: "Done",
        solid: true
      });
    },

    getWizard() {
      return this.$refs.wizard;
    },

    goToWizardStep(index) {
      let wizard = this.getWizard();

      if (!wizard) {
        return;
      }

      let currentIndex = wizard.activeTabIndex;

      if (index > this.maxUnlockedStep) {
        return;
      }

      if (this.currentStep === 4 && index < 4) {
        return;
      }

      if (index < currentIndex) {
        this.resetStepsAfter(index);
      }

      if (typeof wizard.changeTab === "function") {
        wizard.changeTab(currentIndex, index);
        this.currentStep = index;
        return;
      }

      if (typeof wizard.navigateToTab === "function") {
        wizard.navigateToTab(index);
        this.currentStep = index;
      }
    },

    async beforeChangeStep1() {
      try {
        const response = await axios.post(this.$api_url + "/leave-attendance/overtime-runs", {
          month: this.month,
          year: this.year
        });

        if (response.data.approved) {
          this.$bvToast.toast("An approved overtime run already exists for this month. You cannot create another one.", {
            title: "Error",
            variant: "danger",
            solid: true
          });
          return false;
        }

        return true;
      } catch (error) {
        this.serverError(error);
        return false;
      }
    },

    async viewOvertime(row) {
      try {
        this.overtimeDetails = [];
        this.employee = {
          name: "",
          employee_code: "",
          pic: "",
          company_id: null
        };
        this.selectedOvertimeId = row.id;
        this.selectedOvertimeRow = row;
        this.selectAllFinal = false;
        this.loading = true;

        axios.get(
            this.$api_url + "/leave-attendance/overtime/details",
            {
              params: {
                from: row.attendance_from,
                to: row.attendance_to
              }
            }
        ).then(response => {
          this.overtimeDetails = response.data.map(x => ({
            ...x,
            final: Number(x.final || 0),     // saved state (drives the status column)
            selected: Number(x.final || 0),  // pending checkbox state
          }));

          this.selectAllFinal = this.overtimeDetails.length > 0 && this.overtimeDetails.every(item => Number(item.selected) === 1);
        });
      } catch (e) {
        this.serverError(e);
      } finally {
        this.loading = false;
      }
    },

    closeOvertimeDetailsModal() {
      this.$bvModal.hide("overtime-details-modal");
      this.$bvModal.hide("overtime-detail-preview-modal");
    },

    async applyAndShowRunModal() {
      if (this.overtimeDetails.length == 0) return;

      const valid = await this.$validator.validateAll();      
      if (!valid) {        
        this.$bvToast.toast("Overtime field may only contain numeric characters", 
        {          
          title: "Validation", 
          variant: "warning", 
          solid: true        
        });        
        return;      
      }

      try {
        const formData = new FormData();

        const dates = this.overtimeDetails.map(item => moment(item.date, "YYYY-MM-DD"));
        const from = moment.min(dates).format("YYYY-MM-DD");
        const to = moment.max(dates).format("YYYY-MM-DD");

        const idFinalMap = this.overtimeDetails.reduce((acc, item) => {
            acc[item.id] = Number(item.selected || 0);   // was item.final
            return acc;
          }, {});

        const idPOvertimeMap = this.overtimeDetails.reduce((acc, item) => {
          acc[item.id] = Number(item.p_overtime || 0);
          return acc;
        }, {});

        formData.append("p_overtimes", JSON.stringify(idPOvertimeMap));
        const employee_id = this.overtimeDetails[0].employee_id;

        formData.append("from", from);
        formData.append("to", to);
        formData.append("status", 1);
        formData.append("employee_id", employee_id);
        formData.append("overtime_id", this.selectedOvertimeId);
        formData.append("action", "apply");
        formData.append("overtime", JSON.stringify(idFinalMap));

        this.loading = true;
        await axios.post(this.$api_url + "/leave-attendance/overtime/update", formData);
        this.overtimeDetails.forEach(item => this.$set(item, 'final', Number(item.selected || 0)));
        const reloadFormData = this.buildRequestFormData();
        const previewResponse = await axios.post(this.$api_url + "/leave-attendance/overtime/preview", reloadFormData);
        this.overtimes = previewResponse.data || [];
        this.$bvModal.hide("overtime-details-modal");
        this.$bvModal.hide("overtime-detail-preview-modal");
        this.$emit('reloadData');
      } catch (e) {
        this.serverError(e);
      } finally {
        this.loading = false;
      }
    },

    goBackFromRunModal() {
      this.$bvModal.hide("overtime-run-modal");
      this.$bvModal.show("overtime-details-modal");
    },

    async runOvertimeSettle() {
      if (this.overtimeDetails.length == 0) return;

      try {
        const formData = new FormData();

        const dates = this.overtimeDetails.map(item => moment(item.date, "YYYY-MM-DD"));
        const from = moment.min(dates).format("YYYY-MM-DD");
        const to = moment.max(dates).format("YYYY-MM-DD");

        const idFinalMap = this.overtimeDetails.reduce((acc, item) => {
          acc[item.id] = Number(item.final || 0);
          return acc;
        }, {});

        const employee_id = this.overtimeDetails[0].employee_id;

        formData.append("from", from);
        formData.append("to", to);
        formData.append("status", 2);
        formData.append("employee_id", employee_id);
        formData.append("overtime_id", this.selectedOvertimeId);
        formData.append("overtime", JSON.stringify(idFinalMap));

        this.loading = true;

        await axios.post(this.$api_url + "/leave-attendance/overtime/update", formData);

        this.$bvModal.hide("overtime-run-modal");

        const reloadFormData = this.buildRequestFormData();

        const previewResponse = await axios.post(this.$api_url + "/leave-attendance/overtime/preview", reloadFormData);

        this.overtimes = previewResponse.data || [];

        const settledRow = this.overtimes.find(row => row.employee_id == employee_id);

        if (settledRow) {
          this.settledSummary = {
            compensatory_leave: settledRow.compensatory_leave || 0,
            salary_days: settledRow.salary_days || 0,
            salary_type_label: settledRow.salary_type || "-",
          };
        }

        this.$bvToast.toast("Overtime settled successfully.", {
          solid: true,
          title: "Success",
          variant: "success"
        });

        this.maxUnlockedStep = 5;
        this.goToWizardStep(4);
      } catch (e) {
        this.serverError(e);
      } finally {
        this.loading = false;
      }
    },

    async applyOvertime(status) {
      this.$bvModal.msgBoxConfirm("Are you sure?", {
        title: "Please Confirm",
        size: "sm",
        buttonSize: "sm",
        okVariant: "primary",
        okTitle: "Yes",
        cancelTitle: "Cancel",
        bodyClass: "text-center",
        footerClass: "p-2 border-0 d-flex justify-content-center",
        hideHeaderClose: false,
        centered: true
      }).then(async value => {
        if (!value) {
          return;
        }

        if (this.overtimeDetails.length == 0) {
          return;
        }

        try {
          let formData = new FormData();

          const dates = this.overtimeDetails.map(item => {
            return moment(item.date, "YYYY-MM-DD");
          });

          const from = moment.min(dates).format("YYYY-MM-DD");
          const to = moment.max(dates).format("YYYY-MM-DD");

          const idFinalMap = this.overtimeDetails.reduce((acc, item) => {
            acc[item.id] = Number(item.final || 0);
            return acc;
          }, {});

          const employee_id = this.overtimeDetails[0].employee_id;

          formData.append("from", from);
          formData.append("to", to);
          formData.append("status", status);
          formData.append("employee_id", employee_id);
          formData.append("overtime_id", this.selectedOvertimeId);
          formData.append("overtime", JSON.stringify(idFinalMap));

          this.loading = true;

          const response = await axios.post(
              this.$api_url + "/leave-attendance/overtime/update",
              formData
          );

          this.$bvToast.toast(response.data.message, {
            solid: true,
            title: "Success",
            variant: "success"
          });

          const reloadFormData = this.buildRequestFormData();

          const previewResponse = await axios.post(
              this.$api_url + "/leave-attendance/overtime/preview",
              reloadFormData
          );

          this.overtimes = previewResponse.data || [];

          this.overtimeDetails = [];
          this.selectedOvertimeId = null;
          this.selectedOvertimeRow = null;
          this.employee = { name: "", employee_code: "", pic: "", company_id: null };

          this.$bvModal.hide("overtime-details-modal");
          this.$bvModal.hide("overtime-detail-preview-modal");
          this.goToWizardStep(3);
        } catch (e) {
          this.serverError(e);
        } finally {
          this.loading = false;
        }
      });
    },

    async ignoreOvertime(row) {
      this.$bvModal.msgBoxConfirm("Ignore overtime for " + row.name + "?", {
        title: "Please Confirm",
        size: "sm",
        okVariant: "danger",
        okTitle: "Ignore",
        cancelTitle: "Cancel",
        centered: true,
        bodyClass: "text-center",
        footerClass: "p-2 border-0 d-flex justify-content-center",
      }).then(async value => {
        if (!value) {
          return;
        }

        try {
          const formData = new FormData();
          formData.append("status", 2);
          formData.append("employee_id", row.employee_id);
          formData.append("from", row.attendance_from);
          formData.append("to", row.attendance_to);
          formData.append("overtime_id", row.id);

          this.loading = true;

          const response = await axios.post(
              this.$api_url + "/leave-attendance/overtime/update",
              formData
          );

          this.$bvToast.toast(response.data.message, {
            solid: true,
            title: "Success",
            variant: "success"
          });

          const reloadFormData = this.buildRequestFormData();

          const previewResponse = await axios.post(
              this.$api_url + "/leave-attendance/overtime/preview",
              reloadFormData
          );

          this.overtimes = previewResponse.data || [];
        } catch (e) {
          this.serverError(e);
        } finally {
          this.loading = false;
        }
      });
    },

    toggleSelectAllOvertimes() {
      if (this.selectAllOvertimes) {
        let filtered = this.overtimes.filter(el => el.salary_settled == 0);
        this.selectedOvertimeRows = filtered.map(row => row.id);
      } else {
        this.selectedOvertimeRows = [];
      }
    },

    bulkSettleOvertimes() {
      const allDraft = this.overtimes.length > 0 && this.overtimes.every(r => Number(r.status) === 1 && Number(r.salary_settled) === 0);

      if (!allDraft) {
        this.$bvToast.toast("Please change all status to draft to view summary", {
          title: "Validation",
          variant: "warning",
          solid: true
        });
        return;
      }

      this.bypassStep5Validation = true;
      this.maxUnlockedStep = 5;
      this.$nextTick(() => {
        this.goToWizardStep(4);
      });
    },

    async bulkDraftOvertimes() {
      this.$bvModal.msgBoxConfirm("Save selected overtimes as draft?", {
        title: "Confirm Save as Draft",
        size: "sm",
        okVariant: "success",
        okTitle: "Save",
        cancelTitle: "Cancel",
        centered: true,
        bodyClass: "text-center",
        footerClass: "p-2 border-0 d-flex justify-content-center",
      }).then(async value => {
        if (!value) {
          return;
        }

        try {
          const formData = new FormData();
          formData.append("action", "apply");
          formData.append("status", 1);
          formData.append("overtime_id", JSON.stringify(this.selectedOvertimeRows));

          this.loading = true;

          const response = await axios.post(
              this.$api_url + "/leave-attendance/overtime/update",
              formData
          );

          this.$bvToast.toast(response.data.message, {
            solid: true,
            title: "Success",
            variant: "success"
          });

          const reloadFormData = this.buildRequestFormData();

          const previewResponse = await axios.post(
              this.$api_url + "/leave-attendance/overtime/preview",
              reloadFormData
          );

          this.overtimes = previewResponse.data || [];
          this.selectedOvertimeRows = [];
          this.selectAllOvertimes = false;
        } catch (e) {
          this.serverError(e);
        } finally {
          this.loading = false;
        }
      });
    },

    graceAllOvertimeDetails() {
      this.overtimeDetails.forEach(item => this.$set(item, "final", 1));

      this.$bvToast.toast("All daily overtime entries marked as final.", {
        variant: "info",
        title: "Graced All",
        solid: true
      });
    },


    getCompanyLeaveSettings:function()
    {
      if(!this.checkNet()) return false;
      axios.get(this.$api_url+'/leave-attendance/company/leave/settings').then(function(response){

        if(response.data.length != 0)
        {
          this.payrun_date = response.data.payrun_date;
        }

      }.bind(this));

    },

    validateDate() {
      let today = new Date();
      let currentYear = today.getFullYear();
      let currentMonth = today.getMonth() + 1;

      if (Number(this.year) == currentYear && Number(this.month) > currentMonth) {
        this.$bvToast.toast("Future date can't be accessed!", {
          title: "Warning",
          variant: "warning",
          solid: true
        });
        return false;
      }

      return true;
    },
  },

  created() {
    this.viewOvertime(this.row);
  }
};
</script>
